import AppRouter from "@/Routers/AppRouter";
import PatientRouter from "@/Routers/PatientRouter";
import PublicRouter from "@/Routers/PublicRouter";

const routers = { PatientRouter, PublicRouter, AppRouter };

export default routers;
